import React from "react";
import { useVCOnboarding } from "../../contexts/VCOnboardingContext";
import Step1FundInfo from "../../pages/vc-onboarding/steps/Step1FundInfo";
import Step2InvestmentFocus from "../../pages/vc-onboarding/steps/Step2InvestmentFocus";
import Step3Integrations from "../../pages/vc-onboarding/steps/Step3Integrations";
import Step4Insights from "../../pages/vc-onboarding/steps/Step4Insights";
import Step5Preferences from "../../pages/vc-onboarding/steps/Step5Preferences";
import styles from "../../pages/vc-onboarding/VCOnboarding.module.css";

const VCOnboardingContainer: React.FC = () => {
  const { currentStep } = useVCOnboarding();

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <Step1FundInfo />;
      case 2:
        return <Step2InvestmentFocus />;
      case 3:
        return <Step4Insights />; // Insights now at step 3
      case 4:
        return <Step3Integrations />; // Integrations now at step 4
      case 5:
        return <Step5Preferences />;
      default:
        return <Step1FundInfo />;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.logo}>
          <div className={styles.logoText}>
            SendUpdates<span className={styles.logoTextHighlight}>.ai</span>
          </div>
        </div>
        <div className={styles.subtitle}>VC Portal Setup</div>
      </div>

      <div className={styles.progressContainer}>
        <div className={styles.progressBar}>
          {[1, 2, 3, 4, 5].map((step) => (
            <div
              key={step}
              className={`${styles.progressStep} ${
                step < currentStep ? styles.completed : ""
              } ${step === currentStep ? styles.active : ""}`}
            />
          ))}
        </div>
        <div className={styles.progressLabel}>Step {currentStep} of 5</div>
      </div>

      {renderStep()}
    </div>
  );
};

export default VCOnboardingContainer;
